import BlueTableHeading from "../../../../common/AdminCommonComponents/BlueTableHeading/BlueTableHeading"
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import DynamicTableFilters from "../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters"
import StatusBadge from "../../../../common/AdminCommonComponents/StatusBadge/StatusBadge"

const LoanOverview = () => {
  const actions = [
    { label: "View Details", action: console.log("") },
    { label: "Edit", action: console.log("") },
    { label: "Delete", action: console.log("") },
    { label: "Quick Change", action: console.log("") },
  ]

  const tableData = [
    {
      sr: "1",
      applicationID: "#12345",
      sellerName: "Lorem ipsum",
      loanType: "Short-term",
      loanAmount: "$500,000",
      applicationDate: "05/12/2024",
      status: "Approved",
    },
    {
      sr: "2",
      applicationID: "#12345",
      sellerName: "Lorem ipsum",
      loanType: "Short-term",
      loanAmount: "$500,000",
      applicationDate: "05/12/2024",
      status: "Approved",
    },
    {
      sr: "3",
      applicationID: "#12345",
      sellerName: "Lorem ipsum",
      loanType: "Short-term",
      loanAmount: "$500,000",
      applicationDate: "05/12/2024",
      status: "Approved",
    },
    {
      sr: "4",
      applicationID: "#12345",
      sellerName: "Lorem ipsum",
      loanType: "Short-term",
      loanAmount: "$500,000",
      applicationDate: "05/12/2024",
      status: "Approved",
    },
    {
      sr: "5",
      applicationID: "#12345",
      sellerName: "Lorem ipsum",
      loanType: "Short-term",
      loanAmount: "$500,000",
      applicationDate: "05/12/2024",
      status: "Approved",
    },
    {
      sr: "6",
      applicationID: "#12345",
      sellerName: "Lorem ipsum",
      loanType: "Short-term",
      loanAmount: "$500,000",
      applicationDate: "05/12/2024",
      status: "Approved",
    },
    {
      sr: "7",
      applicationID: "#12345",
      sellerName: "Lorem ipsum",
      loanType: "Short-term",
      loanAmount: "$500,000",
      applicationDate: "05/12/2024",
      status: "Approved",
    },
  ]

  const columns = [
    {
      name: "Sr. No",
      selector: (row) => row.sr,
      grow: 0.3,
    },
    {
      name: "Application ID",
      selector: (row) => row.applicationID,
    },
    {
      name: "Seller Name",
      selector: (row) => row.sellerName,
    },
    {
      name: "Loan Type",
      selector: (row) => row.loanType,
    },
    {
      name: "Loan Amount",
      selector: (row) => row.loanAmount,
    },
    {
      name: "Application Date",
      selector: (row) => row.applicationDate,
    },
    {
      name: "Status",
      cell: (row) => <StatusBadge statusName={row.status} />,
    },
    {
      name: "Actions",
      cell: () => <ActionButton options={actions} />,
      center: "true",
    },
  ]

  return (
    <div className="bg-white shadow mt-3">
      <BlueTableHeading className="px-4 py-3 fw-semibold fs-5">Loan Applications</BlueTableHeading>

      <DynamicTableFilters componentName="Pricing Finance & Payment Loan Applications" />

      <div className="p-3">
        <DynamicDatatable data={tableData} columns={columns} type="gray" pagination />
      </div>
    </div>
  )
}

export default LoanOverview
